<div class="game-location" *ngIf="game.team.sport.isRugby()">
  <div class="court">
    <mtg-svg-icon icon="icons-pin"></mtg-svg-icon>
    {{ game.tournamentCourt.name }}
  </div>
  <div class="date">
    {{ game.datetime | date: 'dd MMMM' }}, {{ game.datetime | date: 'HH:mm' }}
  </div>

</div>
<div class="game-header">
  <div class="team-info">
    <div class="team-attributes">
      <div class="team-logo">
        <mtg-svg-icon class="award-left" icon="custom-award-left" *ngIf="game.teamWinnerId === game.team.id"></mtg-svg-icon>
        <mtg-svg-icon class="award-right" icon="custom-award-right" *ngIf="game.teamWinnerId === game.team.id"></mtg-svg-icon>
        <a [routerLink]="teamRoute" [queryParams]="queryParams">
          <img [src]="game.team.logo.path" *ngIf="game.team.logo.path"
               [alt]="game.team.logo.path" />
          <div [class]="game.team.getEmptyLogoClass()" *ngIf="!game.team.logo.path"></div>
        </a>
      </div>
      <div class="team-meta">
        <div class="city">{{ game.team.city.name }}</div>
        <div class="name">
          <a [routerLink]="teamRoute" [queryParams]="{season_id: game.tournament.seasonId}">{{ game.team.name }}</a>
        </div>
      </div>
    </div>
    <div class="team-score" [ngClass]="{winner: game.teamWinnerId === game.team.id}">
      {{ game.teamScore }}
    </div>
  </div>
  <div class="center">
    <div class="game-score">
      <span>{{ game.teamScore }}</span>
      <span class="divider">:</span>
      <span>{{ game.competitorTeamScore }}</span>
    </div>
    <div class="period-score" *ngIf="game.team.sport.isClassicBasketball()">
      <div class="period" *ngFor="let item of game.scoreByPeriodList">
        <div class="title" *ngIf="game.basketballGameConfig.periodsCount >= item.period">{{ item.period }}</div>
        <div class="title" *ngIf="game.basketballGameConfig.periodsCount < item.period">O{{ item.period - game.basketballGameConfig.periodsCount }}</div>
        <div class="score">{{ item.teamScore }} : {{ item.competitorTeamScore }}</div>
      </div>
    </div>
    <div class="period-score" *ngIf="game.team.sport.isVolleyball()">
      <div class="period" *ngFor="let item of game.scoreByPeriodList">
        <div class="title">{{ item.period }}</div>
        <div class="score">{{ item.teamScore }} : {{ item.competitorTeamScore }}</div>
      </div>
    </div>
    <div class="period-score" *ngIf="game.team.sport.isHockey()">
      <ng-container *ngFor="let item of game.scoreByPeriodList">
        <div class="period" *ngIf="item.period <= game.hockeyGameConfig.bullitsPeriod">
          <div class="title" *ngIf="game.hockeyGameConfig.periodsCount >= item.period">{{ item.period }}</div>
          <div class="title" *ngIf="item.period === game.hockeyGameConfig.overtimePeriod">OТ</div>
          <div class="title" *ngIf="item.period === game.hockeyGameConfig.bullitsPeriod">Б</div>
          <div class="score">{{ item.teamScore }} : {{ item.competitorTeamScore }}</div>
        </div>
      </ng-container>
    </div>
    <div class="period-score" *ngIf="game.team.sport.isFootball()">
      <div class="period" *ngFor="let item of game.scoreByPeriodList">
        <div class="title" *ngIf="game.footballGameConfig.periodsCount >= item.period">{{ item.period }}</div>
        <div class="title" *ngIf="game.footballGameConfig.periodsCount < item.period && game.footballGameConfig.penaltyPeriod !== item.period">O{{ item.period - game.footballGameConfig.periodsCount }}</div>
        <div class="title" *ngIf="game.footballGameConfig.penaltyPeriod === item.period">П</div>
        <div class="score">{{ item.teamScore }} : {{ item.competitorTeamScore }}</div>
      </div>
    </div>
    <div class="period-score" *ngIf="game.team.sport.isHandball()">
      <div class="period" *ngFor="let item of game.scoreByPeriodList">
        <div class="title" *ngIf="game.handballGameConfig.periodsCount >= item.period">{{ item.period }}</div>
        <div class="title" *ngIf="game.handballGameConfig.periodsCount < item.period">O{{ item.period - game.handballGameConfig.periodsCount }}</div>
        <div class="score">{{ item.teamScore }} : {{ item.competitorTeamScore }}</div>
      </div>
    </div>
  </div>
  <div class="team-info">
    <div class="team-attributes">
      <div class="team-logo">
        <mtg-svg-icon class="award-left" icon="custom-award-left" *ngIf="game.teamWinnerId === game.competitorTeam.id"></mtg-svg-icon>
        <mtg-svg-icon class="award-right" icon="custom-award-right" *ngIf="game.teamWinnerId === game.competitorTeam.id"></mtg-svg-icon>
        <a [routerLink]="competitorTeamRoute" [queryParams]="queryParams">
          <img [src]="game.competitorTeam.logo.path" *ngIf="game.competitorTeam.logo.path"
               [alt]="game.competitorTeam.name" />
          <div [class]="game.competitorTeam.getEmptyLogoClass()" *ngIf="!game.competitorTeam.logo.path"></div>
        </a>
      </div>
      <div class="team-meta">
        <div class="city">{{ game.competitorTeam.city.name }}</div>
        <div class="name">
          <a [routerLink]="competitorTeamRoute" [queryParams]="{season_id: game.tournament.seasonId}">{{ game.competitorTeam.name }}</a>
        </div>
      </div>
    </div>
    <div class="team-score" [ngClass]="{winner: game.teamWinnerId === game.competitorTeam.id}">
      {{ game.competitorTeamScore }}
    </div>
  </div>
</div>
<div class="playoff-bullits period-score" *ngIf="game.team.sport.isHockey() && game.scoreByPeriod && game.scoreByPeriod[game.hockeyGameConfig.playoffOvertimePeriod] && !game.scoreByPeriod[game.hockeyGameConfig.playoffBullitsPeriod]">
  <div class="period">
    <div class="title">Овертайм на победителя серии</div>
    <div class="score">{{ game.scoreByPeriod[game.hockeyGameConfig.playoffOvertimePeriod][0] }} : {{ game.scoreByPeriod[game.hockeyGameConfig.playoffOvertimePeriod][1] }}</div>
  </div>
</div>
<div class="playoff-bullits period-score" *ngIf="game.team.sport.isHockey() && game.scoreByPeriod && game.scoreByPeriod[game.hockeyGameConfig.playoffBullitsPeriod]">
  <div class="period">
    <div class="title">Буллиты на победителя серии</div>
    <div class="score">{{ game.scoreByPeriod[game.hockeyGameConfig.playoffBullitsPeriod][0] }} : {{ game.scoreByPeriod[game.hockeyGameConfig.playoffBullitsPeriod][1] }}</div>
  </div>
</div>
